import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DeleteReduxDataLogin,
  DeleteReduxDataOtp,
} from "../../api/Actions/SsoB3/DeleteReduxDataLogin";
import backgroundImage from "../../assets/images/loginPict3.jpg";
import LoginImage from "../../assets/images/RoundLogin.png";
import InputDomain from "./InputDomain";
import InputOtp from "./InputOtp";
import InputUser from "./InputUser";
import SelectOrg from "./SelectOrg";
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const login = useSelector((state) => state.ReduxState.login);
  const loginProcess = useSelector((state) => state.ReduxState.loginProcess);

  const HandleBackButton = () => {
    dispatch({
      type: "set",
      loginProcess: "domain",
    });
    localStorage.removeItem("domain");
    localStorage.removeItem("sessionToken");
    dispatch(DeleteReduxDataLogin());
    dispatch(DeleteReduxDataOtp());
  };

  // useEffect(() => {
  //  check login status
  // if (localStorage.getItem("sessionToken")) {
  //   // dispatch({ type: "set", login: true });
  //   dispatch({ type: "set", menu: "/" });
  //   // navigate("/");
  // }
  // }, []);

  // console.log(loginProcess);
  return (
    <div className="flex flex-col w-full sm:flex-row h-screen">
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`,
          objectFit: "cover",
          backgroundSize: "cover",
          // backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="flex flex-col w-full h-full max-h-screen"
      >
        <div className="w-1/2">
          <div className="flex flex-col w-full h-56">
            <div className="flex w-full h-20 mt-auto">
              {loginProcess !== "domain" ? (
                <div>
                  {loginProcess === "user" || "org" ? (
                    <button
                      onClick={(e) => HandleBackButton()}
                      className="text-white poppins-500 mx-6"
                    >
                      BACK
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="flex w-full h-10 mb-0">
              <p className="text-2xl sm:text-3xl poppins-800 text-white uppercase my-auto mx-auto tracking-xl">
                Login
              </p>
            </div>
          </div>
          <div className="flex flex-col w-full h-full">
            {loginProcess === "domain" ? (
              <InputDomain />
            ) : loginProcess === "user" ? (
              <InputUser />
            ) : loginProcess === "otp" ? (
              <InputOtp />
            ) : loginProcess === "org" ? (
              <SelectOrg />
            ) : (
              ""
            )}
            {/* <div className="w-auto -mb-0 sm:h-32 md:h-40 xl:h-56 lg:flex">
            <img className="flex h-full w-full" src={LoginImage} />
          </div> */}
          </div>
        </div>
      </div>
      {/* <div
        className="w-full hidden sm:flex "
        // style={{
        //   backgroundImage: `url(${backgroundImage})`,
        //   objectFit: "cover",
        //   backgroundSize: "cover",
        // }}
      ></div> */}
    </div>
  );
};

export default Login;
